import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AtxFormlyComponent } from './components';
import { AtxFormlyHorizontalWrapperComponent } from './wrappers';
import { AtxSelectFormlyComponent } from '../../entry/select/components';
import { AtxSelectModule } from '../../entry/select';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        FormlyBootstrapModule,

        FormlyModule.forRoot({
            wrappers: [
                {
                    name: 'field-horizontal',
                    component: AtxFormlyHorizontalWrapperComponent,
                },
            ],
            types: [
                {
                    name: 'atxSelect',
                    component: AtxSelectFormlyComponent,
                    wrappers: [
                        'fieldset',
                        'label',
                    ] ,
                },
            ],
        }),

        AtxSelectModule,
    ],
    declarations: [
        AtxFormlyComponent,
        AtxFormlyHorizontalWrapperComponent,
    ],
    exports: [
        AtxFormlyComponent,
    ],
})

export class AtxFormlyModule {}
